module.exports = __webpack_public_path__ + "img/refresh-cw-03.4cb9667e.svg";